"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.renderSearchResult = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _Utils = require("../../Utils");

var _Lists = require("../../Lists");

var _useInput3 = _interopRequireDefault(require("./useInput"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var renderSearchResult = function renderSearchResult(obj) {
  if (Object.keys(obj).length === 0) return null;
  var filtered = Object.entries(obj).filter(function (x) {
    return x[1].length > 0;
  });
  if (filtered.length === 0) return /*#__PURE__*/_react["default"].createElement(_core.Box, {
    mt: 5
  }, "No match");
  return /*#__PURE__*/_react["default"].createElement(_core.Box, {
    mt: 5,
    role: "region",
    id: "search-results",
    "aria-live": "polite"
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true
  }, filtered.map(function (x) {
    return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 4,
      lg: 3,
      key: x[0]
    }, /*#__PURE__*/_react["default"].createElement(_Lists.Archer, {
      subheader: x[0],
      lists: x[1]
    }));
  })));
};

exports.renderSearchResult = renderSearchResult;

var SearchIcon = function SearchIcon(_ref) {
  var handleOpen = _ref.handleOpen;
  return /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    "aria-label": "Open search dialog",
    onClick: handleOpen,
    color: "inherit"
  }, /*#__PURE__*/_react["default"].createElement(_icons.Search, null));
};

SearchIcon.propTypes = {
  handleOpen: _propTypes["default"].func.isRequired
};

var SearchOverlay = function SearchOverlay(_ref2) {
  var searchRequest = _ref2.searchRequest,
      onSubmitCallback = _ref2.onSubmitCallback;
  var initialState = {
    data: {},
    error: null
  };

  var _useInput = (0, _useInput3["default"])(),
      _useInput2 = _slicedToArray(_useInput, 2),
      _useInput2$ = _useInput2[0],
      value = _useInput2$.value,
      error = _useInput2$.error,
      _useInput2$2 = _useInput2[1],
      onChange = _useInput2$2.onChange,
      reset = _useInput2$2.reset;

  var _React$useState = _react["default"].useState(initialState),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      data = _React$useState2[0],
      setData = _React$useState2[1];

  var handleReset = function handleReset() {
    setData(initialState);
    reset();
  };

  var handleSubmit = function handleSubmit(e) {
    if (e) e.preventDefault();
    if (error != null) return; // eslint-disable-next-line consistent-return

    return searchRequest(value).then(function (d) {
      if (d == null || !Object.values(d).every(Array.isArray)) throw new Error('Expected an objects of arrays');
      return typeof onSubmitCallback === 'function' ? onSubmitCallback(d) : setData({
        data: d,
        error: null
      });
    })["catch"](function (err) {
      setData(_objectSpread(_objectSpread({}, data), {}, {
        error: err.message
      }));
      return err;
    });
  };

  _react["default"].useEffect(function () {
    if (value) {
      handleSubmit();
    } else {
      setData(initialState);
    }
  }, [value]);

  return /*#__PURE__*/_react["default"].createElement(_Utils.Dialog, {
    ButtonComponent: SearchIcon,
    onExit: handleReset,
    fullScreen: true,
    id: "search",
    title: "Search"
  }, function () {
    return /*#__PURE__*/_react["default"].createElement(_core.Container, null, /*#__PURE__*/_react["default"].createElement("form", {
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react["default"].createElement(_core.TextField, {
      value: value,
      onChange: onChange,
      id: "search",
      "aria-controls": "search-results",
      "aria-label": "Enter a search term",
      variant: "outlined",
      color: "primary",
      helperText: error || '',
      error: Boolean(error),
      fullWidth: true,
      required: true,
      inputProps: {
        autoComplete: 'off'
      } // eslint-disable-next-line
      ,
      InputProps: {
        startAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
          position: "start"
        }, /*#__PURE__*/_react["default"].createElement(_icons.Search, null))
      }
    })), data.error && /*#__PURE__*/_react["default"].createElement("p", null, data.error), renderSearchResult(data.data));
  });
};

SearchOverlay.defaultProps = {
  onSubmitCallback: null
};
SearchOverlay.propTypes = {
  searchRequest: _propTypes["default"].func.isRequired,
  onSubmitCallback: _propTypes["default"].func
};
var _default = SearchOverlay;
exports["default"] = _default;